module.exports = __webpack_public_path__ + "static/media/feature_flag_description.a8e167dc.png";